import "vanilla-cookieconsent/dist/cookieconsent.css"
import "./styles/consent-theme.css"
import * as CookieConsent from "vanilla-cookieconsent"
import { getConsentCookieDomain } from "./utils/consent-domain"
import { syncGoogleAnalyticsConsent } from "./utils/google-analytics"
import { syncPosthogConsent } from "./utils/posthog"

const CONSENT_COOKIE_DOMAIN = getConsentCookieDomain()

function syncAnalyticsConsent() {
    syncPosthogConsent()
    syncGoogleAnalyticsConsent()
}

CookieConsent.run({
    cookie: {
        domain: CONSENT_COOKIE_DOMAIN,
        expiresAfterDays: 365,
    },
    guiOptions: {
        consentModal: { layout: "box", position: "bottom left", equalWeightButtons: true },
        preferencesModal: { layout: "box" },
    },
    categories: {
        necessary: { enabled: true, readOnly: true },
        analytics: {
            autoClear: {
                cookies: [{ name: /^(_ga|_gid|ph_)/, domain: CONSENT_COOKIE_DOMAIN }],
            },
        },
        marketing: {
            autoClear: {
                cookies: [{ name: /^(_fbp|_fbc|li_|lms_|bcookie|_tt|muc_ads)/ }],
            },
        },
    },
    onConsent: syncAnalyticsConsent,
    onChange: syncAnalyticsConsent,
    language: {
        default: "en",
        translations: {
            en: {
                consentModal: {
                    title: "We value your privacy",
                    description:
                        "We use cookies to understand how the app is used and to measure our marketing. You can accept, reject, or fine-tune them — the app works either way.",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Preferences",
                    footer: '<a href="/privacy" target="_blank">Privacy Policy</a>',
                },
                preferencesModal: {
                    title: "Cookie preferences",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close",
                    sections: [
                        {
                            title: "Strictly necessary",
                            description:
                                "Required for the app to function and remember your consent choice.",
                            linkedCategory: "necessary",
                        },
                        {
                            title: "Analytics",
                            description:
                                "Helps us understand app usage and diagnose issues (Google Analytics, PostHog, Segment, Fathom).",
                            linkedCategory: "analytics",
                        },
                        {
                            title: "Marketing",
                            description:
                                "Measures our advertising and affiliate attribution (Meta, LinkedIn, X, FirstPromoter).",
                            linkedCategory: "marketing",
                        },
                        {
                            title: "More information",
                            description:
                                'See our <a href="/privacy" target="_blank">Privacy Policy</a>.',
                        },
                    ],
                },
            },
        },
    },
})
